import { createContext, ReactNode, useContext } from "react";
import { WebProjectItemModel } from "./types";
import { WallpaperId } from "../../../config/wallpapers";

export type LoadStatus = "loading" | "ready" | "error";

// Desktop-wide data and settings, so windows (My Computer, Control Panel, etc.)
// can read the Hygraph projects and change settings without prop drilling.
export interface DesktopContextType {
  projects: WebProjectItemModel[];
  loadStatus: LoadStatus;
  wallpaper: WallpaperId;
  setWallpaper: (id: WallpaperId) => void;
  soundOn: boolean;
  toggleSound: () => void;
  crtOn: boolean;
  toggleCrt: () => void;
  refreshDesktop: () => void;
  shutDown: () => void;
}

const DesktopContext = createContext<DesktopContextType | undefined>(undefined);

export const DesktopProvider = ({
  value,
  children,
}: {
  value: DesktopContextType;
  children: ReactNode;
}) => (
  <DesktopContext.Provider value={value}>{children}</DesktopContext.Provider>
);

export const useDesktop = () => {
  const context = useContext(DesktopContext);
  if (!context) {
    throw new Error("useDesktop must be used within DesktopProvider");
  }
  return context;
};
